import React, { useState } from "react";
import {
  Image,
  Platform,
  StyleSheet,
  Text,
  AsyncStorage,
  View,
  BackHandler,
} from "react-native";

import { StackActions, NavigationActions } from "@react-navigation/native";
import BackgroundUser from "../components/BackgroundUser";
import Title from "../components/Title";
import Logo from "../components/Logo";
import InputPersonas from "../components/InputPersonas";
import ButtonLayout from "../components/ButtonLayout";
import makeRequest from "../components/makeRequest";
import Constants from "expo-constants";
import * as Permissions from "expo-permissions";
import { Notifications } from "expo";

export default function (props) {
  const meses = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre",
  ];
  const week = [
    "Domingo",
    "Lunes",
    "Martes",
    "Miércoles",
    "Jueves",
    "Viernes",
    "Sábado",
  ];
  const dayOfWeek = week[props.route.params.day.getDay()];
  const day = props.route.params.day;
  const time = props.route.params.time;
  const ninos = props.route.params.ninos;
  const adultos = props.route.params.adultos;
  const nombreInstalacion = props.route.params.instalaciones.nombre;
  return (
    <BackgroundUser>
      {console.log(props.route.params.instalaciones)}

      <Logo navigation={props.navigation}></Logo>
      <View>
        <Title
          style={{
            fontFamily: "Montserrat-Bold",
            color: "#7175CE",
            textAlign: "left",
            marginLeft: 40,
            marginRight: 40,
            fontSize: 24,
          }}>
          Tu cita es:
        </Title>
        <Title
          style={{
            fontFamily: "Montserrat-Bold",
            color: "#3E4672",
            textAlign: "left",
            marginLeft: 40,
            marginRight: 40,
            fontSize: 22,
          }}>
          {nombreInstalacion}
        </Title>
        <Title
          style={{
            fontFamily: "Montserrat-Bold",
            color: "#7175CE",
            textAlign: "left",
            marginLeft: 40,
            marginRight: 40,
            fontSize: 24,
          }}>
          {dayOfWeek}, {day.getDate()} de {meses[day.getMonth()]} a las{" "}
          {time.horas}:{time.minutos}
        </Title>
        <Title
          style={{
            fontFamily: "Montserrat-Bold",
            color: "#3E4672",
            textAlign: "left",
            marginLeft: 40,
            marginRight: 40,
            fontSize: 16,
          }}>
          A nombre de:
        </Title>
        <Title
          style={{
            fontFamily: "Montserrat-Bold",
            color: "#7175CE",
            textAlign: "left",
            marginLeft: 40,
            marginRight: 40,
            fontSize: 22,
            textTransform: "capitalize",
          }}>
          {props.route.params.userInfo.nombre +
            " " +
            props.route.params.userInfo.apellido}
        </Title>
        <Title
          style={{
            fontFamily: "Montserrat-Bold",
            color: "#3E4672",
            textAlign: "left",
            marginLeft: 40,
            marginRight: 40,
            fontSize: 16,
          }}>
          {adultos} {adultos == 1 ? "adulto" : "adultos"}
        </Title>
        <Title
          style={{
            fontFamily: "Montserrat-Bold",
            color: "#3E4672",
            textAlign: "left",
            marginLeft: 40,
            marginRight: 40,
            fontSize: 16,
          }}>
          {ninos} {ninos == 1 ? "niño" : "niños"}
        </Title>
      </View>
      <ButtonLayout
        text='Confirmar'
        onPress={() => {
          let inicio = new Date(
            new Date(props.route.params.day).setHours(
              props.route.params.time.horas
            )
          );
          inicio.setMinutes(props.route.params.time.minutos);
          let finalCalc = new Date(inicio.toISOString());
          finalCalc.setMinutes(
            finalCalc.getMinutes() + props.route.params.duracion
          );
          let finish = false;
          const postCita = async () => {
            setTimeout(() => {
              finish = true;
            }, 1000);
            const response = await makeRequest("citas", "post", {
              instalacion: props.route.params.instalaciones._id,
              aforo: props.route.params.aforo._id,
              inicio: inicio,
              final: finalCalc.toISOString(),
              aceptada: false,
              cancelada: false,
              ninos: parseInt(ninos),
              adultos: parseInt(adultos),
            });
            if (response[0] == 400 && !finish) {
              props.navigation.navigate("ConfirmacionCita", { success: false });
            } else {
              props.navigation.navigate("ConfirmacionCita", {
                success: true,
              });
            }
          };
          postCita();
        }}
      />
      <View></View>
    </BackgroundUser>
  );
}
